import { StemType } from '@arpeggi/shared'
import React, { useEffect } from 'react'
import { useDrop } from 'react-dnd'
import { useTreeState } from '../../../stores/Root'
import { SelectedTrackContainerTabs } from '../SelectedTrackContainer'
import { StudioDraggableTypes } from '../StudioUtils'
import useHandleRef from './useHandleRef'

const useSelectedTrackContainer = (
  stemIndex: number,
  onResize: (resizeHeight: number) => void,
  close: () => void
) => {
  const [selectedTab, setSelectedTab] = React.useState(SelectedTrackContainerTabs.pianoRoll)
  const [selectedDrumTrack, setSelectedDrumTrack] = React.useState<number>(0)
  const { studio } = useTreeState()
  const handleRef = useHandleRef(onResize)

  const song = studio.song
  const stem = song.stems[stemIndex]
  if (!stem) {
    close()
    return null
  }

  const isDrums = stem?.type() === StemType.DRUMS

  // For dropping a new sample
  const [{ isOver }, drop] = useDrop(
    () => ({
      accept: [StudioDraggableTypes.SAMPLE],
      drop: (item: any, monitor) => {
        if (monitor.didDrop()) return
        // Item is a remixableStemMetadata object.
        if (item.type === StudioDraggableTypes.STEM) {
          studio.updateStemWithProtoRemix(stemIndex, item.remixableStemMetadata)
          return
        }
        console.log('dropped a new sample: ', item.sample)
        // TODO condense these all into a single method
        switch (stem.type()) {
          case StemType.DRUMS:
            studio.addDrumSampleToStem(item.sample, stemIndex)
            break
          case StemType.INSTRUMENT:
            studio.updateMelodicStemSample(stemIndex, item.sample)
            break
          case StemType.AUDIO:
            studio.addClipFromSampleToAudioStem(item.sample, stemIndex)
            break
        }
      },
      collect: (monitor) => ({
        isOver: !!monitor.isOver()
      })
    }),
    [stemIndex]
  )

  useEffect(() => {
    if (isDrums) setSelectedTab(SelectedTrackContainerTabs.pianoRoll)
  }, [stem])

  return {
    handleRef,
    selectedTab,
    setSelectedTab,
    selectedDrumTrack,
    setSelectedDrumTrack,
    drop
  }
}

export default useSelectedTrackContainer
